let _ = t => t,
  _t;
import { PANTERA } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/js/constants/Breakpoints';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import { NavItemEnum, SegmentedNavItems } from '../../../constants/routing/NavItems';
import { useAddOnsPage } from '../../../hooks/useAddOnPage';
import { usePageParams } from '../../../hooks/usePageParams';
import { isUngatedForMarketingPlusSelector } from '../../../selectors/GatingSelectors';
import { useSSM0002Experiment } from '../../../utils/experiments/ssm0002';
import CurrencyPicker from '../../common/CurrencyPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SideNavContainer = styled.div.withConfig({
  displayName: "SideNav__SideNavContainer",
  componentId: "fo2g46-0"
})(["z-index:1;min-width:200px;& > nav > ul{margin-left:12px;margin-right:12px;& > li > a{padding:14px;}}& > nav > hr{background-color:", ";width:90%;}@media (min-width:", "px) and (max-width:", "px){min-width:178px;}@media (min-width:", "px) and (max-width:", "px){min-width:110px;margin:0 20px 0 0;}"], PANTERA, breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1);
const Container = styled.div.withConfig({
  displayName: "SideNav__Container",
  componentId: "fo2g46-1"
})(["margin:0 36px 0 0;position:sticky;top:85px;", ";"], breakpoint.tablet(_t || (_t = _`
    margin: 0 34px 0 0;
  `)));
const SideNav = ({
  selectedNavItem
}) => {
  const {
    tab
  } = usePageParams();
  const isUngatedToMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const {
    showAddonsPage
  } = useAddOnsPage();
  const {
    isSSM0002Loading,
    isSSM0002Variant
  } = useSSM0002Experiment();
  const shouldHideNavSection = section => {
    return section === 'enhancements' && !showAddonsPage;
  };
  const shouldHideNavItem = item => {
    return item === NavItemEnum.MARKETING_PLUS && !isUngatedToMarketingPlus || item === NavItemEnum.ADD_ONS && !showAddonsPage ||
    // don't show bundle link while experiments are still loading or if is SSM-0002 variant
    item === NavItemEnum.BUNDLE && (isSSM0002Loading || isSSM0002Variant);
  };
  const hasTabs = navItem => {
    return NavItemEnum.BUNDLE !== navItem && NavItemEnum.FREE !== navItem && NavItemEnum.COMMERCE !== navItem && NavItemEnum.MARKETING_PLUS !== navItem && NavItemEnum.ADD_ONS !== navItem;
  };
  const getPath = navItem => {
    const path = `/${navItem}`;
    return hasTabs(navItem) && tab ? `${path}/${tab}` : path;
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(SideNavContainer, {
      children: Object.keys(SegmentedNavItems).map((navSection, index) => {
        if (shouldHideNavSection(navSection)) return null;
        return /*#__PURE__*/_jsx(UIRouterSideNav, {
          divider: index !== 0,
          headingText: I18n.text(`pricingPage.sidenav.sections.${navSection}`),
          children: SegmentedNavItems[navSection].map(navItem => {
            if (shouldHideNavItem(navItem)) return null;
            return /*#__PURE__*/_jsx(UIRouterSideNavItem, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.products.tabs.${navItem}.tabTitle`
              }),
              className: selectedNavItem === navItem ? 'is-active' : undefined,
              to: createToObject(getPath(navItem))
            }, navItem);
          })
        }, navSection);
      })
    }), /*#__PURE__*/_jsx(CurrencyPicker, {})]
  });
};
export default SideNav;